__turbopack_context__.v({
  "animate-shine": "XLdpBW_animate-shine",
  "shine": "XLdpBW_shine",
  "shine-overlay": "XLdpBW_shine-overlay",
});
